"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColorScheme = exports.useTheme = exports.useThemeContext = exports.ThemeContext = exports.ColorScheme = exports.Theme = void 0;
const react_1 = require("react");
exports.Theme = {
    legacy: 'legacy',
    modern: 'modern',
};
exports.ColorScheme = {
    light: 'light',
    dark: 'dark',
    system: 'system',
};
exports.ThemeContext = (0, react_1.createContext)(undefined);
/** A React hook that returns the theme context if within a ThemeProvider, otherwise undefined */
const useThemeContext = () => {
    return (0, react_1.useContext)(exports.ThemeContext);
};
exports.useThemeContext = useThemeContext;
/** A React hook for accessing the theme */
const useTheme = () => {
    const context = (0, exports.useThemeContext)();
    return context?.theme;
};
exports.useTheme = useTheme;
/** A React hook for accessing the color scheme */
const useColorScheme = () => {
    const context = (0, exports.useThemeContext)();
    return context?.colorScheme;
};
exports.useColorScheme = useColorScheme;
//# sourceMappingURL=themeContext.js.map